if (!customElements.get('hotspot-items')) {
  class HotspotItems extends HTMLElement {
    constructor() {
      super();
      this.items = this.querySelectorAll('.hotspot');
      
      document.addEventListener('click', (e) => {
        if(!e.target.closest('.hotspot')) {
          this.closeAllHotspots();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
          this.closeAllHotspots();
        }
      });

      if(this.items.length){
        this.bindItems();
      }

    }

    closeAllHotspots() {
      this.items.forEach((item) => {
        item.classList.remove('active');
        const content = item.querySelector('.hotspot-content');
        if (content) {
          content.setAttribute('aria-expanded', 'false');
        }
      });
    }

    bindItems() {
      this.items.forEach((item) => {
        const btn = item.querySelector('button');
        const content = item.querySelector('.hotspot-content');
        btn.addEventListener('click', (e) => {
          e.stopPropagation();

          //if item is active, remove the active class
          if (item.classList.contains('active')) {
            item.classList.remove('active');
            if (content) {
              content.setAttribute('aria-expanded', 'false');
            }
            return;
          }

          this.items.forEach((i) => {
            i.classList.remove('active');
            const iContent = i.querySelector('.hotspot-content');
            if (iContent) {
              iContent.setAttribute('aria-expanded', 'false');
            }
          });
          item.classList.add('active');
          if (content) {
            content.setAttribute('aria-expanded', 'true');
          }
          setTimeout(() => {
            item.classList.remove('bottom-up');
            this.adjustHotspotPosition(item);
          }, 100);
        });
      });
    }

    adjustHotspotPosition(item) {
      const content = item.querySelector('.hotspot-content');
      if (!content) return;

      // Reset any previous positioning classes and inline styles
      content.classList.remove('bottom-up');
      content.style.left = '';

      // Force a reflow to ensure measurements are accurate
      void content.offsetHeight;

      const container = this;
      const containerRect = container.getBoundingClientRect();
      const contentRect = content.getBoundingClientRect();
      
      let leftAdjustment = 0;
      
      // Check if content overflows the right edge
      if (contentRect.right > containerRect.right) {
        const overflow = contentRect.right - containerRect.right;
        leftAdjustment = -overflow - 10;
      }
      
      // Check if content overflows the left edge
      if (contentRect.left < containerRect.left) {
        const overflow = containerRect.left - contentRect.left;
        leftAdjustment = overflow + 10;
      }
      
      // Apply left adjustment if needed
      if (leftAdjustment !== 0) {
        content.style.left = `calc(50% + ${leftAdjustment}px)`;
      }
      
      // Check if content overflows the bottom edge
      if (contentRect.bottom > containerRect.bottom) {
        content.classList.add('bottom-up');
      }
    }

  }
  customElements.define('hotspot-items', HotspotItems);
}
